<template>
    <div>
        <div v-if="responded" class="text-muted">
            <i class="fas fa-check mr-1"/>
            Es wurde bereits eine Antwort gegeben.
        </div>
        <div v-else>
            <textarea class="form-control" rows="6" :placeholder="placeholder ? placeholder : 'Antwort'"
                      v-model="message"></textarea>
            <button type="button"
                    class="btn mt-3"
                    :class="{'btn-primary': responseLength > 0, 'btn-outline-primary disabled': responseLength === 0}"
                    @click="send"
            >
                <i class="fas fa-paper-plane mr-1"/>
                {{ __('actions.send_response') }}
            </button>
        </div>
    </div>
</template>

<script>
export default {
    name: 'Response',

    props: {
        alreadyResponded: Boolean,
        placeholder: String,
        url: String,
    },

    data() {
        return {
            responded: false,
            message: '',
        };
    },

    mounted() {
        this.responded = this.alreadyResponded;
    },

    methods: {
        send() {
            if (this.responseLength === 0) {
                return;
            }

            this.$inertia.post(this.url, {
                message: this.message.trim(),
            });
        },
    },

    computed: {
        responseLength() {
            return this.message.trim().length;
        }
    }
};
</script>
